import type { FunctionComponent } from 'react'
import React, { useContext, useRef, useState } from 'react'

import { FormEntryPage } from '../../../../shared/pages/FormEntryPage'
import { ToolContext } from '../../../../shared/state/appContext'
import type { FormEntryInputRef, SingleInputState } from '../../../../shared/types/toolTypes'
import { cleanText } from '../../../../shared/utils/cleanText'
import { formatToolName } from '../../../../shared/utils/formatToolName'
import { isNotEmpty } from '../../../../shared/utils/isNotEmpty'
import { generalDataLayer } from '../../../../shared/utils/tracking'
import { TicketNumberFlow, TicketReasonFlow } from '../../pageFlowData'
import { data } from './data'

export const TicketNumber: FunctionComponent = () => {
  const { state, dispatch } = useContext(ToolContext)
  const {
    initial: { entryToolName },
    ticket: { ticketNumber },
  } = state

  const [inputData, setInputData] = useState<SingleInputState>({
    renderError: false,
    value: '',
  })
  const TicketNumberInput = useRef<FormEntryInputRef>(null)

  const getValue = () => {
    return cleanText(TicketNumberInput?.current?.formEntryInput?.value || '')
  }

  const handleTracking = () => {
    const trackingAnswer = `question | ${TicketNumberFlow.VIEW_NAME} | PII`
    generalDataLayer(formatToolName(entryToolName), trackingAnswer, false)
  }

  const handleDispatch = (value: string) => {
    dispatch({ type: 'UPDATE_TICKET_NUMBER', data: value })
    dispatch({ type: 'UPDATE_STEP', data: TicketReasonFlow.STEP })
    dispatch({ type: 'UPDATE_PROGRESS_VALUE', data: TicketReasonFlow.PROGRESS_VALUE })
  }

  const handleSubmit = () => {
    const value = getValue()
    const isValid: boolean = isNotEmpty(value)

    setInputData({
      renderError: !isValid,
      value: value,
    })

    if (isValid) {
      handleTracking()
      handleDispatch(value)
    }
  }

  const { renderError, value: errorValue } = inputData
  const { imgObj, title } = data

  return (
    <FormEntryPage
      buttonText="Next"
      defaultValue={ticketNumber}
      fieldData={{
        renderError: renderError,
        value: errorValue,
      }}
      handleSubmit={handleSubmit}
      id="ticket-number"
      imgObj={imgObj}
      isFocused
      placeholderText=""
      ref={TicketNumberInput}
      testId="ticket-number"
      title={title}
    />
  )
}
